/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './upsertOption.defs.js'
export { main as default } from './upsertOption.defs.js'
